function formatMoney(value, enabled, hideCurrency) {
  if (typeof enabled === 'boolean' && !enabled) {
    return '-.-'
  }
  // const thousands = '.'
  // const decimal = ','
  let result = ''
  // let fraction, integer, str
  let num = Number(value)
  num = Number.isNaN(num) ? 0 : Math.trunc(num) // 要求所有数字不保留小数
  result = String(num).replace(/(\d)(?=(\d{3})+$)/g, '$1.')
  // if (Number.isInteger(num)) {
  //   result = String(num).replace(/(\d)(?=(\d{3})+$)/g, '$1.')
  // } else {
  //   num = num.toFixed(2)
  //   str = num.split('.')
  //   integer = str[0]
  //   fraction = str[1]
  //   for (let i = integer.length; i > 0; i -= 3) {
  //     if (i < integer.length) {
  //       result = thousands + result
  //     }
  //     result = integer.slice(Math.max(0, i - 3), i) + result
  //   }
  //   if (fraction) {
  //     result += decimal + fraction
  //   }
  // }
  return num < 0 ? '--' : hideCurrency ? result : 'Rp ' + result
}

function formatDate(value, separator) {
  return window.vue.moment(value).format(`YYYY${separator}MM${separator}DD`)
}

export default {
  install(Vue, options = {}) {
    Vue.filter('formatMoney', formatMoney)
    Vue.filter('formatDate', formatDate)
  },
}
